import React from "react";
import PageLayout from "@/components/layout/PageLayout";
import { Hero, Section, SectionHeader, Bento } from "@/components/layout/Sections";
import { CreditCard, Coins, Shield, Truck, FileText } from "lucide-react";

export default function AutoServizi() {
  return (
    <PageLayout>
      <Hero
        image="/showroom/auto.png"
        eyebrow="Auto · Servizi"
        title="Servizi che semplificano la vita"
        subtitle="Finanziamenti, permute, garanzie, consegna a domicilio: tutti i tasselli per un acquisto sereno."
      />
      <Section>
        <SectionHeader
          eyebrow="Cosa offriamo"
          title="Servizi Auto"
        />
        <Bento
          items={[
            { icon: <CreditCard size={22} />, eyebrow: "Finanziamenti", title: "Rate su misura", body: "Piani flessibili, tassi vantaggiosi, risposta in giornata.", span: "md:col-span-2" },
            { icon: <Coins size={22} />, eyebrow: "Permuta", title: "Valutazione immediata", body: "Il tuo usato analizzato e valutato al giusto prezzo.", span: "md:col-span-2" },
            { icon: <Shield size={22} />, eyebrow: "Garanzia", title: "Estensione fino a 5 anni", body: "Copertura estesa su vetture nuove e usate selezionate.", span: "md:col-span-2" },
            { icon: <Truck size={22} />, eyebrow: "Consegna", title: "A casa o in showroom", body: "Scegli tu dove ritirare la tua nuova auto.", span: "md:col-span-3" },
            { icon: <FileText size={22} />, eyebrow: "Pratiche", title: "Passaggi di proprietà", body: "Gestiamo tutto noi: burocrazia zero pensieri.", span: "md:col-span-3", tone: "dark" },
          ]}
        />
      </Section>
    </PageLayout>
  );
}
